var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"at-empty-conversation"},[_c('i',{class:_vm.listIcon}),(_vm.isSidebarProps)?_c('span',[_vm._v(_vm._s(_vm.no_results))]):_c('span',[_vm._v(_vm._s(_vm.start_conv))])])}
var staticRenderFns = []

export { render, staticRenderFns }